import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import B2BLayout from '../../layouts/b2b'
import fetchAPI, { IHttpError } from '../../../lib/utils/fetch-api'
import { CollectionObjectList } from '../../components/app-collection-object-list/collection-object-list'
import { ResultStatusType } from 'antd/lib/result'
import { Result, Skeleton } from 'antd'

export function AdminObjectsListPage() {
  const location = useLocation()
  const { name } = useParams()  as any
  const [collectionMetadata, setCollectionMetadata] = useState({})
  const [loading, setLoading] = useState(true)

  interface IError {
    code?: ResultStatusType
    message?: string
  }
  const [error, setError] = useState<null | IError>(null)

  const breadcrumbs = useMemo(() => (
    [{
      href: '/admin',
      title: 'Администрирование'
    }, {
      href: '/admin/collections',
      title: 'Справочники',
    }, {
      href: location.pathname,
      title: (collectionMetadata && collectionMetadata['title']) || '...',
    }]
  ), [collectionMetadata, location.pathname])

  useEffect(() => {
    const getData = async () => {
      setError(null)
      setLoading(true)
      await fetchAPI(`/api/collections/${name}/metadata`)
        .then(metadataResult => {
          if (metadataResult?.data && typeof metadataResult.data === 'object') {
            const data = metadataResult.data
            setCollectionMetadata(data)
          }
        })
        .catch(e => {
          console.error({ e })
          setError({
            message: (e as IHttpError)?.message || 'Неизвестная ошибка',
            code: ((e as IHttpError)?.statusCode || 'error') as ResultStatusType,
          })
        })
        .finally(() => {
          setLoading(false)
        })
    }

    getData()
  }, [])

  return (
    <B2BLayout breadcrumbs={breadcrumbs}>
      {loading && <Skeleton active/>}
      {!loading && error && <Result status={error.code} title='Ошибка' subTitle={error.message} />}
      {!loading && !error && <CollectionObjectList collectionName={name} />}
    </B2BLayout>
  )
}
